import { render, staticRenderFns } from "./EditAttachments.vue?vue&type=template&id=2c4a5154&"
import script from "./EditAttachments.vue?vue&type=script&lang=js&"
export * from "./EditAttachments.vue?vue&type=script&lang=js&"
import style0 from "./EditAttachments.vue?vue&type=style&index=0&id=2c4a5154&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports